module.exports = __webpack_public_path__ + "static/media/warning.626dfd07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning.svg
// module id = 91
// module chunks = 3